/************************************************************************
 ** IBM Confidential
 **
 ** IBM Business Analytics: Rapidly Adaptive Visualization Engine
 **
 ** (C) Copyright IBM Corp. 2020
 **
 ** The source code for this program is not published or otherwise divested of its trade secrets, 
 ** irrespective of what has been deposited with the U.S. Copyright Office.
 ************************************************************************/
// GENERATED
import BaseObjectType from './BaseObjectType';
import PropertySetter from './PropertySetter';
import MoserObjectUtils from './MoserObjectUtils';
import MoserObject from './MoserObject';
//@import com/ibm/bi/platform/moser/common/generated/metadata/BaseObjectType (loadtime) // superclass
//@import com/ibm/bi/platform/moser/common/generated/metadata/PropertySetter (runtime) // updateModuleReference
//@import com/ibm/bi/platform/moser/common/utils/MoserObjectUtils (runtime) // propertyOverrideForPropertyType
//@import com/ibm/bi/platform/moser/common/generated/metadata/MoserObject (static) // fromJSONHelper

/**
 * The base metadata object. <p>Java class for objectType complex type. <p>The following schema fragment specifies the expected content contained within this class. <pre> &lt;complexType name="objectType"&gt; &lt;complexContent&gt; &lt;extension base="{}baseObjectType"&gt; &lt;sequence&gt; &lt;element name="identifier" type="{http://www.w3.org/2001/XMLSchema}string"/&gt; &lt;element name="description" type="{http://www.w3.org/2001/XMLSchema}string" minOccurs="0"/&gt; &lt;element name="label" type="{http://www.w3.org/2001/XMLSchema}string" minOccurs="0"/&gt; &lt;element name="comment" type="{http://www.w3.org/2001/XMLSchema}string" minOccurs="0"/&gt; &lt;element name="screenTip" type="{http://www.w3.org/2001/XMLSchema}string" minOccurs="0"/&gt; &lt;element name="hidden" type="{http://www.w3.org/2001/XMLSchema}boolean" minOccurs="0"/&gt; &lt;element name="propertyOverride" type="{http://www.w3.org/2001/XMLSchema}string" maxOccurs="unbounded" minOccurs="0"/&gt; &lt;/sequence&gt; &lt;/extension&gt; &lt;/complexContent&gt; &lt;/complexType&gt; </pre>
 */
export default class ObjectType extends BaseObjectType{

	identifier = null;

	description = null;

	label = null;

	comment = null;

	screenTip = null;

	hidden = null;

	propertyOverride = null;



	/**
	 * Gets the value of the identifier property.
	 * @return {String} possible object is {@link String}
	 */
	getIdentifier() {
		return this.identifier;
	}

	/**
	 * Sets the value of the identifier property.
	 * @param {String} value allowed object is {@link String}
	 */
	setIdentifier(value) {
		var oldValue = this.identifier;
		this.identifier = value;
		this._setAndNotify(38, oldValue, value, false, true);
		PropertySetter.updateModuleReference(this, oldValue, value);
	}

	/**
	 * Gets the value of the description property.
	 * @return {String} possible object is {@link String}
	 */
	getDescription() {
		return this.description;
	}

	/**
	 * Sets the value of the description property.
	 * @param {String} value allowed object is {@link String}
	 */
	setDescription(value) {
		var oldValue = this.description;
		this.description = value;
		this._setAndNotify(7, oldValue, value, false, true);
	}

	/**
	 * Gets the value of the label property.
	 * @return {String} possible object is {@link String}
	 */
	getLabel() {
		return this.label;
	}

	/**
	 * Sets the value of the label property.
	 * @param {String} value allowed object is {@link String}
	 */
	setLabel(value) {
		var oldValue = this.label;
		this.label = value;
		this._setAndNotify(168, oldValue, value, false, true);
	}

	/**
	 * Gets the value of the comment property.
	 * @return {String} possible object is {@link String}
	 */
	getComment() {
		return this.comment;
	}

	/**
	 * Sets the value of the comment property.
	 * @param {String} value allowed object is {@link String}
	 */
	setComment(value) {
		var oldValue = this.comment;
		this.comment = value;
		this._setAndNotify(167, oldValue, value, false, true);
	}

	/**
	 * Gets the value of the screenTip property.
	 * @return {String} possible object is {@link String}
	 */
	getScreenTip() {
		return this.screenTip;
	}

	/**
	 * Sets the value of the screenTip property.
	 * @param {String} value allowed object is {@link String}
	 */
	setScreenTip(value) {
		var oldValue = this.screenTip;
		this.screenTip = value;
		this._setAndNotify(169, oldValue, value, false, true);
	}

	/**
	 * Gets the value of the hidden property.
	 * @return {Boolean} possible object is {@link Boolean}
	 */
	isHidden() {
		return this.hidden;
	}

	/**
	 * Sets the value of the hidden property.
	 * @param {Boolean} value allowed object is {@link Boolean}
	 */
	setHidden(value) {
		var oldValue = this.hidden;
		this.hidden = value;
		this._setAndNotify(8, oldValue, value, false, true);
	}

	/**
	 * Gets the value of the propertyOverride property. <p> This accessor method returns a reference to the live list, not a snapshot. Therefore any modification you make to the returned list will be present inside the JAXB object. This is why there is not a <CODE>set</CODE> method for the propertyOverride property. <p> For example, to add a new item, do as follows: <pre> getPropertyOverride().add(newItem); </pre> <p> Objects of the following type(s) are allowed in the list {@link String}
	 */
	getPropertyOverride() {
		if (!this.propertyOverride) {
			this.propertyOverride = [];
		}
		return this.propertyOverride;
	}

	/**
	 * Gets the value of the <code>propertyOverride</code> property without initializing the property to an empty list if it is unset.
	 * @return {Array} the list of <code>String</code> elements, or <code>null</code> if not set
	 */
	basicGetPropertyOverride() {
		return this.propertyOverride;
	}

	/**
	 * True if this object is imported
	 */
	isImported() {
		if (this.propertyOverride) {
			if (this.propertyOverride.indexOf("Imported")> -1) {
				return true;
			}
			if (this.propertyOverride.indexOf("NEW")> -1) {
				return false;
			}
		}
		var obj = this._parent;
		while (obj) {
			if (("QuerySubject" == obj.getObjectType() || "Folder" == obj.getObjectType()) || "FolderType" == obj.getObjectType()) {
				var parentOverrides = (obj).basicGetPropertyOverride();
				if (parentOverrides) {
					if (parentOverrides.indexOf("Imported")> -1) {
						return true;
					}
					if (parentOverrides.indexOf("NEW")> -1) {
						return false;
					}
				}
			}
			obj = obj.getParent();
		}
		return false;
	}

	/**
	 * Adds the <code>item</code> to the collection at the given position and fires a notification to listeners.
	 */
	addPropertyAt(position, item) {
		this._addAtAndNotify(this.getProperty(), position, item, 87, true, false);
		MoserObjectUtils.propertyOverrideForPropertyType(this, item);
	}

	/**
	 * Creates a new instance of <code>ObjectType</code> object from JSON data.
	 * @param {ObjectFactory} factory <code>ObjectFactory</> object for object creation.
	 * @param {Object} json JSON data to be used to create the <code> ObjectType</code> object from.
	 * @return {ObjectType} an object of type <code>ObjectType</code>
	 */
	static fromJSON(json, factory) {
		var result = factory.createObjectType();
		var featureList = result.getFeatureList(factory);
		MoserObject.fromJSONHelper(result, featureList, json, factory);
		return result;
	}

	/**
	 * Adds the <code>item</code> to the collection at the given position and fires a notification to listeners.
	 */
	addPropertyOverrideAt(position, item) {
		var overrideList = this.getPropertyOverride();
		for (var i = 0; (i < overrideList.length); ++i) {
			var override = overrideList[i];
			if (override == item || override == "NEW") {
				return;
			}
		}
		this._addAtAndNotify(this.getPropertyOverride(), position, item, 166, false, false);
	}

	/**
	 * Adds the <code>item</code> to the end of the collection and fires a notification to listeners.
	 */
	addPropertyOverride(item) {
		this.addPropertyOverrideAt(this.getPropertyOverride().length, item);
	}

	/**
	 * Removes the item at <code>position</code> from the collection and fires a notification to listeners.
	 */
	removePropertyOverrideAt(position) {
		this._removeAtAndNotify(this.getPropertyOverride(), position, 166, false);
	}

	/**
	 * Removes the <code>item</code> from the collection and fires a notification to listeners.
	 */
	removePropertyOverride(item) {
		var i = this.getPropertyOverride().indexOf(item);
		if (i >= 0) {
			this.removePropertyOverrideAt(i);
		}
	}

	/**
	 * Retrieves the type of this object
	 * @return {String} the object type in a <code>String</code>
	 */
	getObjectType() {
		return "ObjectType";
	}

	/**
	 * Get a list of FeatureObjects
	 * @return {Array} A list of FeatureObjects
	 */
	getFeatureList(factory) {
		var featureList = [];
		featureList.push(this.createFeature(false, false, false, 38, "identifier", null));
		featureList.push(this.createFeature(false, false, false, 7, "description", null));
		featureList.push(this.createFeature(false, false, false, 168, "label", null));
		featureList.push(this.createFeature(false, false, false, 167, "comment", null));
		featureList.push(this.createFeature(false, false, false, 169, "screenTip", null));
		featureList.push(this.createFeature(false, false, false, 8, "hidden", null));
		featureList.push(this.createFeature(true, false, false, 166, "propertyOverride", null));
		Array.prototype.push.apply(featureList, super.getFeatureList(factory));
		return featureList;
	}

	/**
	 * Set the value of a specific feature.
	 * @param {BaseMoserObject} value the value to set
	 * @param {int} featureID the feature id of the attribute to be set
	 */
	set(featureID, value) {
		switch (featureID) {
		case 38:
			this.setIdentifier((value));
			break;
		case 8:
			this.setHidden((value));
			break;
		case 7:
			this.setDescription((value));
			break;
		case 167:
			this.setComment((value));
			break;
		case 168:
			this.setLabel((value));
			break;
		case 169:
			this.setScreenTip((value));
			break;
		default:
			super.set(featureID, value);
		}
	}

	/**
	 * Set the value of a specific feature.
	 * @param {BaseMoserObject} value the value to set the value to set
	 * @param {int} featureID the feature id of the attribute to be set the feature id of the attribute to be set
	 */
	_setList(featureID, value) {
		switch (featureID) {
		case 166:
			this.propertyOverride = (value);
			break;
		default:
			super._setList(featureID, value);
		}
	}

	/**
	 * Get the value of a specific feature.
	 * @param {int} featureID the feature id of the attribute to get
	 */
	get(featureID) {
		switch (featureID) {
		case 38:
			return this.getIdentifier();
		case 166:
			return this.getPropertyOverride();
		case 8:
			return this.isHidden();
		case 7:
			return this.getDescription();
		case 167:
			return this.getComment();
		case 168:
			return this.getLabel();
		case 169:
			return this.getScreenTip();
		default:
			return super.get(featureID);
		}
	}

	/**
	 * Get the value of a specific feature.
	 * @param {int} featureID the feature id of the attribute to get
	 */
	basicGet(featureID) {
		switch (featureID) {
		case 38:
			return this.getIdentifier();
		case 166:
			return this.basicGetPropertyOverride();
		case 8:
			return this.isHidden();
		case 7:
			return this.getDescription();
		case 167:
			return this.getComment();
		case 168:
			return this.getLabel();
		case 169:
			return this.getScreenTip();
		default:
			return super.basicGet(featureID);
		}
	}

	/**
	 * Add the value of a specific feature at a specific position
	 * @param {int} position the array position of the item to be added
	 * @param {BaseMoserObject} value the value to add
	 * @param {int} featureID the feature id of the attribute to be added
	 */
	addAt(featureID, position, value) {
		switch (featureID) {
		case 166:
			this.addPropertyOverrideAt(position, (value));
			break;
		default:
			super.addAt(featureID, position, value);
		}
	}

	/**
	 * Add the value to the end of a specific collection feature
	 * @param {BaseMoserObject} value the value to add
	 * @param {int} featureID the feature id of the attribute to be added
	 */
	add(featureID, value) {
		switch (featureID) {
		case 166:
			this.addPropertyOverride((value));
			break;
		default:
			super.add(featureID, value);
		}
	}

	/**
	 * Remove the value of a specific feature by index.
	 * @param {int} position the array position of the item to be removed
	 * @param {int} featureID the feature id of the attribute to be removed
	 */
	removeAt(featureID, position) {
		switch (featureID) {
		case 166:
			this.removePropertyOverrideAt(position);
			break;
		default:
			super.removeAt(featureID, position);
		}
	}

	/**
	 * Remove the value from specific feature.
	 * @param {BaseMoserObject} item the item to be removed
	 * @param {int} featureID the feature id of the attribute to be removed
	 */
	remove(featureID, item) {
		switch (featureID) {
		case 166:
			this.removePropertyOverride((item));
			break;
		default:
			super.remove(featureID, item);
		}
	}
}


// WEBPACK FOOTER //
// ./src/generated/ObjectType.js